export enum AdminSwitchCases {
  login = 'login',
  changePassword = 'changePassword',
  adminPage = 'adminPage',
  resetPassword = 'resetPassword',
}
